import ElementProperty from './element-property';
/**
  @COMMON_NAME: "Nuevo centro"
  @REL_ATTR: 1068102
  @id: 1068102
  sequence: 20
  value: "ISM SEVILLA"
 */
export default class TicketProperty extends ElementProperty {
  constructor(opts = {}) {
    super(opts);

    this.value = opts.value || null;
  }
}
